const zhCN = {
  translation: {
    // Navigation
    nav: {
      aiOs: 'AI OS',
      decision: '决策',
      execution: '执行',
      monitor: '监控',
      opportunityRadar: '机会雷达',
      projects: '创作',
      community: '广场',
      launches: '调度',
      life: '生活',
      shopping: '购物',
      services: '服务',
      business: '商家',
      analytics: '数据',
      memory: '记忆',
      settings: '设置',
      new: 'NEW',
    },
    // Common buttons
    common: {
      login: '登录',
      create: '创作',
      messages: '消息',
      language: '语言',
    },
    // Model selector
    model: {
      label: '模型',
      switchSuccess: '已切换到模型：{{name}}',
      models: {
        gpt4o: 'GPT-4o',
        claude35Sonnet: 'Claude-3.5-Sonnet',
        tongyi: '通义千问',
        deepseek: 'DeepSeek',
        fastgpt: 'FastGPT',
      },
    },
    // Page titles
    page: {
      aiCommandCenter: 'AI 指挥中心',
      home: '首页',
      projects: '创作',
      settings: '设置',
    },
    // Status
    status: {
      online: '{{count}} Agents 在线',
      offline: '离线',
      running: '运行中',
      loading: '加载中...',
      error: '出错了',
    },
  },
};

export default zhCN;
